module.exports = __webpack_public_path__ + "static/media/rypaleiset-kadet.7ba09d06.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/rypaleiset-kadet.jpg
 ** module id = 397
 ** module chunks = 0
 **/